import { render, staticRenderFns } from "./designRightsDialog.vue?vue&type=template&id=be082610&scoped=true"
import script from "./designRightsDialog.vue?vue&type=script&lang=js"
export * from "./designRightsDialog.vue?vue&type=script&lang=js"
import style0 from "./designRightsDialog.vue?vue&type=style&index=0&id=be082610&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be082610",
  null
  
)

export default component.exports